import { Trans } from '@lingui/react/macro';

import { Button } from '@/components/buttons';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/Dialog';
import { Spinner } from '@/components/loaders';

type Props = {
  open: boolean;
  onAbortDownload: () => void;
};

const FileDownloadDialog = ({ open, onAbortDownload }: Props) => {
  const handleOpenChange = () => {
    // Keep this dialog open until download completes or user cancels explicitly.
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>
            <Trans>Your file is being downloaded</Trans>
          </DialogTitle>
          <DialogDescription>
            <Trans>
              It may take a minute or two to download. Please don't navigate away from this screen
              before the download is complete.
            </Trans>
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center gap-6 text-center">
          <Spinner variant="spoke" />
        </div>
        <DialogFooter>
          <Button size="large" onClick={onAbortDownload}>
            <Trans>Cancel Download</Trans>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default FileDownloadDialog;
